module.exports = __webpack_public_path__ + "img/female.d00d5149.png";